module.exports = __webpack_public_path__ + "img/id-verified.9df735c6.png";